import { PaySafeEnvironments } from '@monorepo/client-types';
import {
  PaymentSessionType,
  paySafeAmountByCurrency,
  SupportedCurrencies,
} from '@monorepo/types';
import { EnvService } from '@hub/services/core/env-service';
import { PaysafeSetupConfig } from '@hub/types/paysafe';

const { paysafeEnv } = EnvService.get();

const PAYSAFE_TEST_CURRENCY = SupportedCurrencies.EUR;

export const getPayloadForSetup = (
  paymentSession: PaymentSessionType,
  paySafeAccounts: Record<SupportedCurrencies, string>,
): PaysafeSetupConfig => ({
  initializationTimeout: 20000,
  currency:
    paysafeEnv === PaySafeEnvironments.Live
      ? paymentSession.purchaseSnapshot.paymentData.currency
      : PAYSAFE_TEST_CURRENCY,
  amount: paySafeAmountByCurrency(
    paymentSession.purchaseSnapshot.paymentData.convertedPrice,
    paymentSession.purchaseSnapshot.paymentData.currency,
  ),
  merchantRefNum: paymentSession.sessionId,

  customer: {
    firstName: paymentSession.purchaseSnapshot.billingInformation.firstName,
    lastName: paymentSession.purchaseSnapshot.billingInformation.lastName,
    email: paymentSession.purchaseSnapshot.billingInformation.email,
    phone: paymentSession.purchaseSnapshot.billingInformation.phoneNumber,
    // dateOfBirth: paymentSession.purchaseSnapshot.billingInformation.
    //   ? {
    //       day: dayjs(order.information.birthDate).get('day'),
    //       month: dayjs(order.information.birthDate).get('month'),
    //       year: dayjs(order.information.birthDate).get('year'),
    //     }
    //   : undefined,

    merchantCustomerId: paymentSession.userId,
  },

  displayPaymentMethods: ['card'],
  paymentMethodDetails: {
    card: {
      accountId:
        paySafeAccounts[paymentSession.purchaseSnapshot.paymentData.currency],
    },
  },
  environment: paysafeEnv,

  billingAddress: {
    street:
      paymentSession.purchaseSnapshot.billingInformation.billingAddress.address,
    city: paymentSession.purchaseSnapshot.billingInformation.billingAddress
      .city,
    zip: paymentSession.purchaseSnapshot.billingInformation.billingAddress
      .zipCode,
    country:
      paymentSession.purchaseSnapshot.billingInformation.billingAddress.country,
    state:
      paymentSession.purchaseSnapshot.billingInformation.billingAddress.state &&
      paymentSession.purchaseSnapshot.billingInformation.billingAddress
        .state !== ''
        ? paymentSession.purchaseSnapshot.billingInformation.billingAddress
            .state
        : undefined,
  },

  simulator: paysafeEnv === PaySafeEnvironments.Live ? undefined : 'EXTERNAL',

  threeDs: {
    merchantUrl: `https://api${paysafeEnv === PaySafeEnvironments.Live ? '' : '.test'}.paysafe.com/checkout/v2/index.html#/desktop`,
    useThreeDSecureVersion2: true,
    authenticationPurpose: 'PAYMENT_TRANSACTION',
    deviceChannel: 'BROWSER',
    requestorChallengePreference: 'CHALLENGE_MANDATED',
    transactionintent: 'GOODS_OR_SERVICE_PURCHASE',
    messageCategory: 'PAYMENT',
  },
});
